// istanbul ignore file
import Language from './en-US.json'
import LanguageES from './es-ES.json'
import languageFr from './fr.json'
import languageDe from './de.json'
import languageRu from './ru.json'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const LanguageStrings = () => {
  const language = navigator.language
  let Strings
  if (language.startsWith('es')) {
    Strings = LanguageES
  } else if (language.startsWith('fr')) {
    Strings = languageFr
  } else if (language.startsWith('de')) {
    Strings = languageDe
  } else if (language.startsWith('ru')) {
    Strings = languageRu
  } else {
    Strings = Language
  }
  return (Strings)
}

export default LanguageStrings
